import type { IColumn } from "@similarweb/ui-components";
import type { IColumnsPickerLiteProps } from "@similarweb/ui-components";
import type { CompetitiveColumnType } from "../types/common";

const getColumnsPickerLiteProps = ({
    onClickToggleColumns,
    tableColumns,
}: {
    tableColumns: readonly CompetitiveColumnType[];
    onClickToggleColumns: (selectedColumnIndex: number) => void;
}): Omit<IColumnsPickerLiteProps, "translations"> => {
    const columns = tableColumns.reduce((res: IColumn[], col: CompetitiveColumnType, index: number) => {
        if (!col.fixed) {
            return [
                ...res,
                {
                    key: index.toString(),
                    displayName: col.displayName || "",
                    visible: !!col.visible,
                },
            ];
        }
        return res;
    }, []);
    return {
        columns,
        onColumnToggle: (key) => onClickToggleColumns(parseInt(key, 10)),
        onPickerToggle: () => null,
        maxHeight: 264,
        width: "auto",
    };
};

export default getColumnsPickerLiteProps;
